import { useLocation } from 'react-router-dom';

import { prepareLink } from '@gem/utils';

export default () => {
  const location = useLocation();

  return (data = {}) => {
    return prepareLink({ ...data, location });
  };
};
